
import { Component, signal, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatLabel } from "@angular/material/form-field";
import { MatRadioModule } from "@angular/material/radio";
import { TranslocoPipe } from "@jsverse/transloco";
import { LorenAggregate } from "../../../../shared/enums/loren-aggregate.enum";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "loren-loren-asset-details-charts-dialog",
  imports: [
    MatDialogModule,
    MatRadioModule,
    MatLabel,
    TranslocoPipe,
    MatButton
],
  templateUrl: "./loren-asset-details-charts-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loren-asset-details-charts-dialog.component.scss",
})
export class LorenAssetDetailsChartsDialogComponent {
  dialogRef = inject<MatDialogRef<LorenAssetDetailsChartsDialogComponent>>(MatDialogRef);

  readonly aggregationOptions = LorenAggregate;
  aggregation = signal<LorenAggregate>(LorenAggregate.MINUTES);

  onCancel(): void {
    this.dialogRef.close();
  }
}
